var map = {
	"./brasov.jpg": "d396",
	"./bucuresti-central.jpg": "24c7",
	"./bucuresti-mosilor.jpg": "a491",
	"./bucuresti-unirii.jpg": "9adf",
	"./cluj.jpg": "0586",
	"./logo.png": "cf05",
	"./pitesti.jpg": "767a",
	"./tailwind.css": "ba8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";